enum CustomerType {
    Person = 'Person',
    Company = 'Company',
    Private = 'Private',
    Business = 'Business',
    PrivateFirm = 'PrivateFirm',
}

export default CustomerType;
